<template>
  <div>
    <div class="wrap">
      <img class="login-page-bg" src="@/assets/img/mobile/login-bg-top.png"/>
      <div class="hello">
        <div class="login-logo" v-if="loading"></div>
        <img class="login-logo" :class="{ 'logo-ex': isSpecialCus }" :src="getLogo" v-else />
        <img class="login-welcome" src="@/assets/img/mobile/welcome.png" v-if="!isSpecialCus && !loading" />
      </div>
      <div class="cui-main">
        <div class="login-form">
          <div class="account">
            <input v-model="form.mobile" type="text" placeholder="请输入手机号" :disabled="!isSpecialLink" @blur="getEmpInfo"/>
            <!--<img class="secrecy" @click.stop="clear" src="@/assets/img/mobile/icon-clear.png" v-if="form.mobile" />-->
          </div>
          <div class="password checkCode">
            <input v-model="form.checkCode" type="number" placeholder="请输入验证码" max="999999" />
            <van-button class="code-btn" size="mini" round @click="getVerificationCode" color="linear-gradient(90deg, #4776F0 0%, #3062E1 100%)">
              <span v-if="isFinished">获取验证码</span>
              <template v-else>
                <van-count-down ref="countDown" :time="time" @finish="countDownFinished">
                  <template #default="timeData">
                    <span class="color-white">{{ timeData.seconds }}s</span>
                  </template>
                </van-count-down>
              </template>
            </van-button>
          </div>
        </div>
        <!-- 同意并遵守用户协议 -->
        <div class="regist-tips">
          <van-checkbox v-model="checked" label-class="agree-protocol" checked-color="#3062e1">我已同意并遵守</van-checkbox>
          <span class="agreement primary-color" @click="toPolicyPage('https://hrcloud.ciicpt.com.cn/userAccord.html')">薪税云用户协议</span>和
          <span class="agreement primary-color" @click="toPolicyPage('https://hrcloud.ciicpt.com.cn/ppolicy.html ')">隐私保护政策</span>
        </div>
        <!--登录按钮-->
        <div class="login-button">
          <van-button class="full-button" block round @click="doLogin" color="linear-gradient(90deg, #4776F0 0%, #3062E1 100%)">登录</van-button>
        </div>
      </div>
    </div>
    <img class="bottom-bg" src="@/assets/img/mobile/login-bg-bottom.png" />
    <help-video></help-video>
  </div>

</template>

<script>
  import HelpVideo from './components/HelpVideo'
  import Logo from '@/assets/img/mobile/logo.png'
  import LogoEx from '@/assets/img/mobile/logo-ex.png'
  import { Toast } from 'vant';
  import { validatenull, isvalidatemobile } from "@/util/validate";
  import { getEmpInfoByLinkCode, sendCheckCode, userCodeLogonNew } from '@/api/mobile/mobile'

  export default {
    components: {
      HelpVideo
    },
    data() {
      return {
        Logo,
        LogoEx,
        form: {
          mobile: '',
          checkCode: '',
        },
        getCode: '获取验证码',
        isFinished: true,
        time: 60000,
        cusId: '',
        linkCode: '',
        checked: false,
        logoSign: '',
        loading: false,
        oriLinkCode: '',
        specialCusFlag: ['bjhpa','ciicpt']
      }
    },
    created() {
      this.linkCode = localStorage.getItem('linkCode');
      this.oriLinkCode = this.linkCode;
      if(!this.specialCusFlag.includes(this.oriLinkCode)){
        this.loading = true;
        this.getEmpInfo();
        // this.loading = false;
      }
    },
    methods: {
      toPolicyPage(url) {
        window.location.href = url
      },
      // 获取雇员信息
      getEmpInfo() {
        if(this.specialCusFlag.includes(this.oriLinkCode) && validatenull(this.form.mobile)){ //固定链接，则必须有手机号时，才能查询
          return;
        }
        // this.loading = true
        const params = {
          linkCode: this.oriLinkCode,
          mobile: this.form.mobile
        }
        getEmpInfoByLinkCode(params)
        .then(res => {
          this.loading = false
          this.form.mobile = res.phone
          this.cusId = res.cusId
          localStorage.setItem('empInfo', JSON.stringify(res));
          this.linkCode = res.linkCode;
          this.logoSign = res.specialLink;
        })
        .catch(error => {
          this.loading = false
        })
      },
      // 清除手机号
      clear() {
        this.form.mobile = '';
        this.linkCode = '';
      },
      // 获取验证码
      getVerificationCode() {
        if (this.isFinished) {
          if (isvalidatemobile(this.form.mobile)[0]) {
            Toast(isvalidatemobile(this.form.mobile)[1])
          } else {
            const params = {
              codeNumber: this.form.mobile
            }
            sendCheckCode(params).then(res => {
              this.isFinished = false
              if (this.$refs.countDown) {
                this.$refs.countDown.start();
              }
            })
          }
        }
      },
      // 倒计时结束
      countDownFinished() {
        this.isFinished = true
      },
      // 表单验证
      validateForm() {
        if (validatenull(this.form.mobile)) {
          Toast('请输入手机号')
          return false
        }
        if (validatenull(this.form.checkCode)) {
          Toast('请输入验证码')
          return false
        }
        if (!this.checked) {
          Toast('请先同意薪税云用户协议和隐私保护政策')
          return false
        }
        return true
      },
      // 薪税云登录
      doLogin() {
        if (this.validateForm()) {
          const params = {
            u: this.form.mobile,
            checkCode: this.form.checkCode,
            uid: this.cusId,
            linkCode: this.linkCode
          }
          userCodeLogonNew(params)
          .then(res => {
            localStorage.setItem('token', res)
            localStorage.setItem('linkCode', this.linkCode)
            this.$router.push({
              name: 'AuthorizationLogin'
            })
          })
        }
      }
    },
    computed: {
      isSpecialCus() {
        return this.specialCusFlag.includes(this.$route.params.tid) || this.specialCusFlag.includes(this.logoSign);
      },
      isBjhpaCus(){ //健康促进会
        return this.$route.params.tid === 'bjhpa' || this.logoSign === 'bjhpa';
      },
      isSpecialLink(){
        return this.specialCusFlag.includes(this.$route.params.tid);
      },
      getLogo() {
        if(this.isBjhpaCus) {
          return require('@/assets/img/mobile/logo-ex.png')
        } else {
          return require('@/assets/img/mobile/logo.png')
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .wrap{
    position: absolute;
    color: #666666;
    overflow-y: auto;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 2;
    .login-page-bg {
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }
    .hello {
      padding-top: 1.6rem;
      text-align: center;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      .login-logo {
        /*width: 2.8rem;*/
        height: 0.76rem;
        margin-bottom: 0.36rem;
        &.logo-ex {
          height: 1.2rem;
        }
      }
      .login-welcome {
        width: 5.88rem;
        height: 0.44rem;
      }
    }
    .cui-main {
      width: 6.05rem;
      margin: auto;
      margin-top: 1.85rem;
      .login-form {
        .account, .password {
          margin-bottom: 0.55rem;
          height: 0.9rem;
          background: #F8F8F8;
          border-radius: 0.45rem;
          position: relative;
          padding-left: 0.36rem;
        }
        .account input, .password input{
          width: calc(100% - 0.76rem);
          height: 100%;
          margin-right: 0.1rem;
          color: #333333;
          font-size: 0.26rem;
          border: none;
          background-color: #F8F8F8;
        }
        .secrecy{
          position: absolute;
          top: 50%;
          right: 0.16rem;
          transform: translate(0,-50%);
          z-index: 99;
          width: 0.24rem;
          height: 0.24rem;
          padding: 0.3rem 0.2rem;
        }
        .code-btn {
          flex-shrink: 0;
          position: absolute;
          top: 50%;
          right: 0.2rem;
          transform: translate(0, -50%);
          padding: 0 !important;
          font-size: 0.24rem !important;
          width: 1.8rem;
          height: 0.62rem !important;
          /*background: linear-gradient(90deg, #4776F0 0%, #3062E1 100%);*/
          color: #fff;
        }
      }
      .regist-tips{
        font-size: 0.24rem;
        color: #333;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 1.26rem;
        .agree-protocol {
          padding-left: 0.1rem;
          color: #999;
        }
      }
    }
  }
  .bottom-bg {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 1;
  }
  .agreement {
    padding: 0 3px;
  }
</style>
